import { useEffect } from 'react';
import { trackEvent } from '../components/Analytics'
import { formatEvent } from '../components/Analytics'

const usePageAction = action =>  {
  const isValidAction = type => (
    ['HTMLAnchorElement', 'HTMLButtonElement'].includes(type)
  );

  useEffect(() => {
    const event = formatEvent(action.event);
    isValidAction(action.type) && trackEvent(event)
  }, [action])
}

export default usePageAction;

